export type ValidationError = {
  field: string;
  message: Array<string>;
};

export const getPropShouldNotBeEmptyMessage = (prop: string): string => `${prop} should not be empty`;
export const getPropMaxLengthExceededMessage = (prop: string): string => `${prop} is too long`;
